export default __webpack_public_path__ + "static/media/explore_image.212d78d0.png";